import { render, staticRenderFns } from "./TabPanel.vue?vue&type=template&id=e8cc93ba&scoped=true"
import script from "./TabPanel.vue?vue&type=script&lang=ts"
export * from "./TabPanel.vue?vue&type=script&lang=ts"
import style0 from "./TabPanel.vue?vue&type=style&index=0&id=e8cc93ba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8cc93ba",
  null
  
)

export default component.exports